import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, TemplateRef } from "@angular/core";
import { NzSafeAny } from "ng-zorro-antd/core/types";
import { ɵNzTabNavOperationComponent } from "ng-zorro-antd/tabs";
import { UiTabNavItemDirective } from "../../directives/tab-nav-item.directive";

@Component({
  selector: "ui-tab-nav-operation",
  exportAs: "uiTabNavOperation",
  templateUrl: "./tab-nav-operation.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiTabNavOperationComponent extends ɵNzTabNavOperationComponent {
  @Input() public items: UiTabNavItemDirective[] = [];
  @Input() public addable = false;
  @Input() public addIcon: string | TemplateRef<NzSafeAny> = "plus";

  @Output() public readonly addClicked = new EventEmitter<void>();
  @Output() public readonly selected = new EventEmitter<UiTabNavItemDirective>();

  constructor(public cdr: ChangeDetectorRef, elementRef: ElementRef<HTMLElement>) {
    super(cdr, elementRef);
  }
}
